import { Stack } from "@altimateai/lego";
import ToolInputParameterList from "./ToolInputParameterList";
import { InputParameter } from "./constants";
import { useState } from "react";
import { Button } from "@altimateai/lego";
import { IconTrash } from "@tabler/icons-react";

export type ToolItem = {
  name: string;
  description: string;
  inputs: InputParameter[];
};

interface ToolFieldItemProps {
  toolItem: ToolItem;
  onChange: (updated: ToolItem) => void;
  onRemove: () => void;
}

const ToolFieldItem = ({ toolItem, onChange, onRemove }: ToolFieldItemProps) => {
  const [inputs, setInputs] = useState<InputParameter[]>(toolItem.inputs || []);

  const handleInputsChange = (updatedInputs: InputParameter[]) => {
    onChange({ ...toolItem, inputs: updatedInputs });
    setInputs(updatedInputs);
  };

  return (
    <Stack direction="column" className="al-gap-3 al-p-2">
      <Stack direction="row" className="al-gap-2 al-items-center">
        <p className="al-text-sm al-text-gray-500">{toolItem.description}</p>
        <Button type="button" variant="ghost" size="sm" onClick={onRemove}>
          <IconTrash className="al-w-4 al-h-4 al-text-destructive" />
        </Button>
      </Stack>
      {inputs.length ? (
        <Stack direction="column" className="al-gap-2">
          <h5 className="al-text-sm al-font-medium">Input Parameters</h5>
          <ToolInputParameterList inputs={inputs} onChange={handleInputsChange} allowEdit={false} />
        </Stack>
      ) : null}
    </Stack>
  );
};

export default ToolFieldItem;
